import { useEffect, useState } from 'react'
import { chatApi } from '@carrent/api'

/**
 * Непрочитанное для бейджа в сайдбаре.
 *
 * Опрос раз в минуту, НЕ отдельный SSE-поток: колокольчик и открытая
 * страница чатов уже держат по подключению, а браузер ограничивает
 * их число на хост. Бейджу минутная точность достаточна; общий
 * event-bus на приложение — будущий рефакторинг, не этот этап.
 */
const POLL_MS = 60_000

export function useChatUnread() {
  const [unread, setUnread] = useState(0)

  useEffect(() => {
    let alive = true
    const load = () =>
      chatApi
        .conversations()
        .then(({ data }) => {
          if (!alive) return
          const total = (data.data.items || []).reduce(
            (n, c) => n + (c.unread_count || 0), 0)
          setUnread(total)
        })
        .catch(() => {})

    load()
    const t = setInterval(load, POLL_MS)
    return () => {
      alive = false
      clearInterval(t)
    }
  }, [])

  return unread
}
